module.exports = __webpack_public_path__ + "static/media/group-8-copy_7@2x.b912a6d3.png";